import styled from 'styled-components';

export const GridColumn = styled.div<{ span: number }>`
	grid-column: span ${(props) => props.span};
`;
